import { Upload, Sparkles, Download } from "lucide-react";
import type { LucideIcon } from "lucide-react";

// The three steps reuse the existing `howItWorks.imageGenerator.*` i18n keys
// — there's no need for landing-specific copy, the per-flow tree already has
// the right wording in both HE and EN. We only own the icon assignment here.

export interface HowItWorksStep {
  icon: LucideIcon;
  titleKey: "step1Title" | "step2Title" | "step3Title";
  descKey: "step1Desc" | "step2Desc" | "step3Desc";
}

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  { icon: Upload, titleKey: "step1Title", descKey: "step1Desc" },
  { icon: Sparkles, titleKey: "step2Title", descKey: "step2Desc" },
  { icon: Download, titleKey: "step3Title", descKey: "step3Desc" },
];
